import React, { useState } from 'react';
import { motion } from 'framer-motion';

export const CommunicationIcon: React.FC = () => {
	const [hovered, setHovered] = useState(false);

	return (
		<motion.svg
			width="76"
			height="70"
			viewBox="0 0 76 70"
			fill="none"
			onHoverStart={() => setHovered(true)}
			onHoverEnd={() => setHovered(false)}
		>
			<path
				d="M2 1.25C1.58579 1.25 1.25 1.58579 1.25 2V29.3913C1.25 29.8055 1.58579 30.1413 2 30.1413H7.8442V37C7.8442 37.2804 8.00064 37.5374 8.24974 37.6662C8.49883 37.795 8.79897 37.7741 9.02778 37.612L19.5721 30.1413H23.4783H50C50.4142 30.1413 50.75 29.8055 50.75 29.3913V17.2174V2C50.75 1.58579 50.4142 1.25 50 1.25H2Z"
				fill="white"
				stroke="#F27C00"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M74 25.25C74.4142 25.25 74.75 25.5858 74.75 26V52.6087C74.75 53.0229 74.4142 53.3587 74 53.3587H68.2961V60C68.2961 60.2799 68.1402 60.5366 67.8917 60.6656C67.6433 60.7946 67.3437 60.7745 67.1147 60.6135L56.7982 53.3587H52.9787H26C25.5858 53.3587 25.25 53.0229 25.25 52.6087V40.7826V26C25.25 25.5858 25.5858 25.25 26 25.25H74Z"
				stroke="#F27C00"
				strokeWidth="1.5"
				strokeLinejoin="round"
				fill={hovered ? '#F27C00' : 'white'}
			/>
			<circle cx="37" cy="40" r="2" fill={hovered ? 'white' : '#F27C00'} />
			<circle cx="51" cy="40" r="2" fill={hovered ? 'white' : '#F27C00'} />
			<circle cx="65" cy="40" r="2" fill={hovered ? 'white' : '#F27C00'} />
		</motion.svg>
	);
};
